<template>
    <div class="slide-show">
        <div class="items" :style="{paddingTop:ratio*100+'%'}">
            <transition :name="'slide-'+direction">
                <a :class="['item',{pointer:i.link}]" v-for="(i,idx) in dataCloned" v-if="idx==index" :key="$root.langMode+'item'+idx" :href="i.link" target="blank">
                    <v-image width="100%" height="100%" :src="i.image+'#'+rand()" @load="i.loaded=true" class="image"></v-image>
                    <!-- <div class="loading" v-if="!i.loaded"></div> -->
                </a>
            </transition>
        </div>
        <button class="switch prev" @click="prev" v-if="data.length>1"></button>
        <button class="switch next" @click="next" v-if="data.length>1"></button>
        <ul class="bullets" v-if="data.length>1">
            <li v-for="(i,idx) in data.length" :class="{current:idx==index}" @click="allowClick&&(index=idx)" :key="'bullet'+idx"></li>
        </ul>
    </div>
</template>
<style lang="less" scoped>
    .slide-show {
        position: relative;
        width: 100%;
        overflow: hidden;

        .items {
            position: relative;

            .item {
                position: absolute;
                left: 0;
                top: 0;
                right: 0;
                bottom: 0;
                will-change: transform;
                backface-visibility: hidden;
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: white;

                &.pointer {
                    cursor: pointer;
                }

                .image,
                .loading {
                    width: 100%;
                    height: 100%;
                    background-color: white;
                    object-fit: cover;
                }

                .loading:after {
                    content: "";
                    display: block;
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    border: 3px solid rgba(0, 0, 0, .05);
                    border-right-color: #e60012;
                    position: absolute;
                    left: calc(50% - 25px);
                    top: calc(50% - 25px);
                    animation: rotate .8s linear infinite;
                }
            }
        }

        .switch {
            position: absolute;
            width: 60px;
            height: 60px;
            border-radius: 50%;
            border: 4px solid white;
            background-position: calc(50% + 2px) center;
            background-repeat: no-repeat;
            background-size: 14px;
            top: calc(50% - 30px);
            background-color: transparent;
            background-image: url(../assets/images/slideshow/arrow.png);
            opacity: .3;
            transition: all .3s;

            &:hover {
                opacity: 1;
            }

            &.prev {
                left: 5%;
                transform: rotate(180deg);
            }

            &.next {
                right: 5%;
            }
        }

        .bullets {
            display: flex;
            position: absolute;
            bottom: 50px;
            left: 50%;
            transform: translateX(-50%);
            padding: 0;
            margin: 0;

            li {
                background-color: rgba(255, 255, 255, .6);
                width: 60px;
                height: 10px;
                list-style: none;
                cursor: pointer;
                transition: all .2s;

                &.current {
                    background-color: #e60012;
                }

                &:not(:last-child) {
                    margin-right: 13px;
                }

                &:hover {
                    background-color: #e60012;
                }
            }
        }
    }
    @media screen and (max-width: 1360px) {
        .slide-show {
            .bullets {
                bottom: 20px;
                li {
                    width: 30px;
                    height: 6px;
                }
            }
        }
    
    }
</style>

<script>
    export default {
        props: {
            data: {
                default () {
                    return []
                }
            },
            ratio: {
                default: 0.31
            },
            interval: {
                default: 5000
            },
            auto: {
                default: true
            }
        },
        data() {
            return {
                index: 0,
                itv: undefined,
                direction: undefined,
                dataCloned: [],
                allowClick: true
            }
        },
        methods: {
            next() {
                if (!this.allowClick) return;
                if (this.index < this.data.length - 1) {
                    this.index++;
                } else {
                    this.index = 0;
                }
            },
            prev() {
                if (!this.allowClick) return;
                if (this.index > 0) {
                    this.index--;
                } else {
                    this.index = this.data.length - 1
                }
            },
            rand() {
                return Math.random()
            }
        },
        mounted() {
            if (this.auto) {
                this.itv = setInterval(function () {
                    this.next()
                }.bind(this), this.interval);
            };
            this.dataCloned = this.data.clone();
        },
        watch: {
            index: {
                handler(after, before) {
                    if (after > before) {
                        this.direction = "right"
                    } else {
                        this.direction = "left"
                    }
                    this.allowClick = false;
                    setTimeout(() => {
                        this.allowClick = true
                    }, 800);
                },
                async: false
            },
            data(after) {
                this.dataCloned = after.clone();
            }
        }
    }
</script>